import { DataList } from "widgets/commonDataObjects/dataList"
import { MainNavItemSlotData } from "../../data/mainNav/mainNavItemSlotData"
import { HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink"
import { SiteSimpleImage } from "widgets/commonComponents/inline/siteSimpleImage"
import { LinkTargetProperties } from "../../../../../../global/components/linkSettings/interfaces"

interface MainNavProps {
    items: MainNavitem[]
}

export interface MainNavitem {
    link: string
    linkTarget: LinkTargetProperties
    mediaTitle: string
    color: string
    url: string
    title: string
}

export class MainNavComponenta extends React.Component<MainNavProps, {}> {
    constructor(props) {
        super(props)
    }

    render() {
        const { items } = this.props
        const imageItems = items.filter((item: any) => item.url !== "")
        const textItems = items.filter((item: any) => item.url === "")
        
        return (
            <div className="mainNav no-print" role="navigation" aria-label="Main Menu">
                <ul className="links">
                    {_.map(textItems, (item: any, index: number) =>
                        <li key={`text-${index}`}>
                            <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} ariaLabel={item.mediaTitle} style={{ color: item.color }}>
                                <span dangerouslySetInnerHTML={{ __html: item.title }} />
                            </HyperLinkBuilder>
                        </li>
                    )}
                </ul>
                <ul className="imgs">
                    {_.map(imageItems, (item: any, index: number) =>
                        <li key={`image-${index}`}>
                            <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} ariaLabel={item.mediaTitle} style={{ color: item.color }}>
                                <SiteSimpleImage src={item.url} alt={item.mediaTitle} title={item.mediaTitle} width={"auto"} height={"auto"} />
                            </HyperLinkBuilder>
                        </li>
                    )}
                </ul>
            </div>
        )
    }
}